export const GET_ALL_IMPORTS = "GET_ALL_IMPORTS";
export const GET_ALL_ADMINS = "GET_ALL_ADMINS";
export const RESET_DATA = "RESET_DATA";

// LOADING ACTION TYPES
export const START_LOADING_IMPORTS = "START_LOADING_IMPORTS";
export const STOP_LOADING_IMPORTS = "STOP_LOADING_IMPORTS";
export const ERROR_LOADING_IMPORTS = "ERROR_LOADING_IMPORTS";